/**
 * Created by vidhyasagar on 05.04.18.
 */


export class CoinChange{

  private _coinValue:number;


  constructor(coinValue: number) {
    this._coinValue = coinValue;
  }

  get coinValue(): number {
    return this._coinValue;
  }

  set coinValue(value: number) {
    this._coinValue = value;
  }

}



// WEBPACK FOOTER //
// /Applications/WebStorm.app/Contents/bin/untitled3/Users/vidhyasagar/WebstormProjects/RealTimeAnalytics/CoinMachine/src/app/drink-automatic-machine/coin-change-model.ts